// extracted by mini-css-extract-plugin
module.exports = {"empty-row":"_025a50318d--empty-row--2-WT-"};